import { render, staticRenderFns } from "./SimilarityAlert.vue?vue&type=template&id=61d855ae&"
import script from "./SimilarityAlert.vue?vue&type=script&lang=js&"
export * from "./SimilarityAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports